import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";

function VoiceCloningProcess({ onBack }) {
    const navigate = useNavigate();

    const handleNavigation = () => {
        navigate("/dashboard/voice-cloning/list");
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            handleNavigation();
        }, 6000); // 6000 milliseconds = 6 seconds

        // Cleanup function to clear the timer if the component unmounts
        return () => clearTimeout(timer);
    }, []); // Empty dependency array ensures this runs once when the component mounts

    return (
        <div style={{ padding: "20px" }}>
            <Typography variant="highlightSemibold">
                Creating clone sound
            </Typography>
            <br />
            <Typography variant="supportRegular">
                Your files has been successfully uploaded and now system is
                creating a clone sound, it will take sometime. By the time you
                can wait or perform other task. Don’t worry we will notify you
                once cloning is complete.
            </Typography>
            <br />
            <br />
            <Box sx={{ width: "100%" }}>
                <LinearProgress
                    sx={{
                        marginTop: 2,
                        marginBottom: 2,
                        backgroundColor: "#e0e0e0",
                        height: 10, // Increased height of the loader
                        borderRadius: 5, // Optional: adds rounded corners
                        "& .MuiLinearProgress-bar": {
                            backgroundColor: "#16BB4D",
                        },
                    }}
                />
            </Box>

            <br />

            <Button
                variant="contained"
                sx={{ width: "35%", marginTop: "2rem", marginBottom: "2rem" }}
                onClick={handleNavigation}
            >
                Go Back to Sound Cloning
            </Button>
            {/* <Button
                variant="contained"
                sx={{ width: "35%", marginTop: "2rem", marginBottom: "2rem" }}
                onClick={onBack}
            >
                Go Back
            </Button> */}
        </div>
    );
}

export default VoiceCloningProcess;
